// UI events are supporting evidence; server request logs remain authoritative.
// Never read input values, passwords, clipboard content or complete table rows.
let interaction = ''
let interactionTime = 0
const pending = new Set<Promise<unknown>>()
const newId = () => Array.from(crypto.getRandomValues(new Uint8Array(16)), value => value.toString(16).padStart(2, '0')).join('')
export function auditInteraction() {
  return Date.now() - interactionTime < 3000 ? interaction : ''
}
export function trackUi(event: 'page_view'|'click'|'change'|'open_detail'|'close_detail', control: string, context: Record<string, unknown> = {}) {
  const token = localStorage.getItem('xhs_v2_token')
  if (!token || ['/login', '/change-password'].includes(location.pathname)) return
  if (!auditInteraction()) interaction = newId()
  interactionTime = Date.now()
  const body = JSON.stringify({ event, page: location.pathname, control: control.trim().slice(0,120), interaction_id: interaction, context })
  const request = fetch('/api/v2/action-logs/ui-events', {
    method: 'POST', headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }, body, keepalive: true
  }).then(response => {
    if (!response.ok && response.status !== 401 && response.status !== 403) console.warn('界面留痕未送达', response.status)
  }).catch(() => { console.warn('界面留痕网络不可用') }).finally(() => pending.delete(request))
  pending.add(request)
}

export function installAudit() {
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null
    const control = target?.closest('button, a, [role="button"], [role="tab"], [role="menuitem"], [role="option"], .n-menu-item-content, .n-tabs-tab, .n-pagination-item, .n-base-select-option, .n-checkbox, .n-radio, .n-switch')
    if (!control || control.closest('[data-audit-ignore]') || control.getAttribute('disabled') !== null) return
    interaction = newId(); interactionTime = Date.now()
    const label = control.getAttribute('aria-label') || control.getAttribute('title') || control.textContent || '未命名控件'
    trackUi('click', label.replace(/\s+/g, ' ').trim(), {})
  }, true)
  document.addEventListener('change', event => {
    const target = event.target
    if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return
    if (target instanceof HTMLInputElement && !['checkbox','radio'].includes(target.type)) return
    trackUi('change', target.getAttribute('aria-label') || '调整勾选/选项')
  }, true)
}
